export default {
  name: { defaultValue: '' },
  email: { defaultValue: '' },
  phone: { defaultValue: '' },
  club: { defaultValue: '' },
  address: { defaultValue: '' },
  city: { defaultValue: '' },
  state: { defaultValue: '' },
  country: { defaultValue: '' },
  zip: { defaultValue: '' },
  is_active: { defaultValue: true }
}
